import { useEffect } from "react";
import type { PurchaseEvent } from "~/lib/nativeBridge";

/**
 * ネイティブアプリからの課金完了通知を `purchaseEvent` カスタムイベントに変換する。
 *
 * アプリごとに完了イベント名が異なる:
 * - Hokage: `purchase/completed` (detail: { productId })
 * - CoachMe (Sakura): `purchaseCompleted` (detail: {})
 *
 * 両方をリッスンし、アプリ内部の統一イベント `purchaseEvent` に変換する。
 * `__root.tsx` に 1 個だけマウントする。
 */
export const NativePurchaseBridgeListener = () => {
  useEffect(() => {
    const dispatch = (productId?: string) => {
      const event: PurchaseEvent = {
        status: "succeeded",
        productId: productId ?? "",
      };
      window.dispatchEvent(new CustomEvent("purchaseEvent", { detail: event }));
    };

    // Hokage: purchase/completed (detail に productId あり)
    const handleHokage = (e: Event) => {
      const detail = (e as CustomEvent<{ productId?: string }>).detail;
      dispatch(detail?.productId);
    };

    // CoachMe (Sakura): purchaseCompleted (detail 空)
    const handleCoachMe = () => {
      dispatch();
    };

    window.addEventListener("purchase/completed", handleHokage);
    window.addEventListener("purchaseCompleted", handleCoachMe);
    return () => {
      window.removeEventListener("purchase/completed", handleHokage);
      window.removeEventListener("purchaseCompleted", handleCoachMe);
    };
  }, []);
  return null;
};
